import { LineType, Service } from "@/types/__generated__/union-types"

export const getLineTypeServiceDefault = (lineType?: LineType, patientAge?: number | null): Service | undefined => {
  if (lineType === "KIDS_LINE" && patientAge && patientAge > 18) {
    return "EMERGENCY_LINE"
  } else if (lineType === "TELE_GENERAL_PRACTITIONER_LINE") {
    return "CONSULTATION"
  } else if (lineType === "SWICA_OVERFLOW") {
    return undefined
  }
  return lineType
}

// PatientWithCoveragesForFavorNurse and mayFavorNurseWhenAssigningMedicalAgent should be removed as soon as we have a concept that provides the "Medgate services enabled for the patient"
type PatientWithCoveragesForFavorNurse = {
  readonly insurees?: ReadonlyArray<{
    readonly activeCoverages: ReadonlyArray<{
      readonly product: {
        readonly productConfiguration: {
          readonly nursingRate: boolean | null
        } | null
      }
    }>
  }>
}

// If any of the coverages has nursingRate, then we favor nurses
export const mayFavorNurseWhenAssigningMedicalAgent = (patient: PatientWithCoveragesForFavorNurse) =>
  (patient.insurees ?? [])
    .flatMap((i) => i.activeCoverages)
    .map((c) => c.product.productConfiguration)
    .some((pc) => pc && pc.nursingRate)
